import { Box, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'

import React, { useEffect } from 'react'

import { Barcode } from '../Barcode'
import { ASN } from '../../api/models'

import { skuit } from '../../services/skuit'
import { useQueryPaginator } from '../Table'

const useStyles = makeStyles(() => ({
  label: {
    maxWidth: '90%',
    margin: 'auto',
    border: '1px solid gray',
    borderRadius: '1rem',
    padding: '0.5rem',
  },
}))

interface Props {
  asn: ASN
  onReadyToPrint?: () => void
}

export const TransloadPlacard = (props: Props) => {
  const { asn, onReadyToPrint } = props
  const barcode = { barcode: asn.transloadNumber || '', type: 'datamatrix', displayName: '' }
  const classes = useStyles()

  const palletPaginator = useQueryPaginator('pallet-list', skuit.client.pallets.list, {
    params: { page_size: 1, asns: asn.guid },
  })

  useEffect(() => {
    if (!palletPaginator.loading) {
      onReadyToPrint?.()
    }
  }, [palletPaginator.loading, onReadyToPrint])

  return (
    <div className="always-page-break">
      <Box px={5} pt={5}>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          spacing={2}
          className={classes.label}
        >
          <Grid item xs={3}>
            <Barcode barcode={barcode} />
          </Grid>
          <Grid item xs={9}>
            <Grid item>
              <Typography variant="h1">Transload Placard</Typography>
            </Grid>
            <Grid item>
              <Typography variant="h4">{asn.transloadNumber}</Typography>
            </Grid>
            <Grid item>
              <Typography variant="h3">Printed on {moment().format('lll')}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box px={5}>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          spacing={2}
          className={classes.label}
        >
          <Grid item xs={9}>
            <Grid item>
              <Typography variant="h1">ASN #{asn.trackingNumber}</Typography>
            </Grid>
            <Grid item>
              <Typography variant="h2">Client: {asn.client?.name}</Typography>
            </Grid>
            <Grid item>
              <Typography variant="h5">{asn.guid}</Typography>
            </Grid>
            <Grid item>
              <Typography variant="h4">Pallet Count: {palletPaginator.data.count}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}
